import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";

class LabResultSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("ResultLabel");
    }

    public getItemIconClass(): string {
        return "resultsIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): null {
        return null;
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { LabResultSharedItemProvider };
